import InputPassword from "./InputPassword";
import Button from "@/components/atoms/button";
import { MIN_PASSWORD_LENGTH_FOR_COMPLETE } from "@/consts";
import clsx from "clsx";

interface IProps {  
    password: string | undefined;
    checkPassword: string;
    isCompleteBtnDisabled: boolean;
    isPasswordValid: boolean;
    isCheckPasswordDisabled: boolean;
    onChangePassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onChangeCheckPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onClickCompleteBtn: () => void;
    onBlurPassword: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onKeyDownCheckPassword: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const PasswordForm = ({password, checkPassword, isCompleteBtnDisabled, isPasswordValid, isCheckPasswordDisabled, onChangePassword, onChangeCheckPassword, onClickCompleteBtn, onBlurPassword, onKeyDownCheckPassword}: IProps) => {

    return (
        <div className="inner-set-pnum">
            <h3 className="form-title body-l-n fw-b w">비밀번호 설정</h3>
                <InputPassword className="pw-input" id="password1" placeholder="영문, 숫자, 특수문자 포함 8~20자 입력" label="비밀번호를 입력해주세요" password={password} onChange={onChangePassword} onBlur={onBlurPassword} />   
                {!isPasswordValid && (
                    <div className="alert-msg-join-sms-2 body-s-n">
                        <p>{"비밀번호가 잘못 입력되었습니다."}</p>
                    </div>
                )}
                <InputPassword className="pw-input body-n-n" id="password2" placeholder="비밀번호 확인" label="비밀번호를 다시 입력해주세요" password={checkPassword} isCheckPasswordDisabled={isCheckPasswordDisabled} onChange={onChangeCheckPassword} onKeyDown={onKeyDownCheckPassword} />
                {password !== checkPassword && 
                 password && password.length >= MIN_PASSWORD_LENGTH_FOR_COMPLETE && 
                 checkPassword.length >= 1 && (
                    <div className="alert-msg-join-sms-2 body-s-n">
                        <p>{"비밀번호가 일치하지 않습니다."}</p>
                    </div>
                )}
            <div className="button-area margin-top">
                <Button caption='완료' className={clsx('glass-button body-n-n fw-b', {enabled: !isCompleteBtnDisabled, default_cursor: isCompleteBtnDisabled})} onClick={onClickCompleteBtn} />
            </div>
        </div>
    )
};

export default PasswordForm;

